import React from 'react';

export const SearchIcon = () => {
  return <svg viewBox="0 0 32 32" title="search icon" preserveAspectRatio="xMidYMid meet"><path d="M32 28.4l-8-8A13 13 0 0 0 13.1 0a13.1 13.1 0 1 0 7.4 24l7.9 8 3.6-3.6zM3.5 13.1a9.6 9.6 0 0 1 19.3 0c0 5.4-4.3 9.6-9.7 9.6s-9.6-4.2-9.6-9.6z"></path></svg>;
};
